import noticeService from './notice';
import noticeStore from '../store/index';
import { action, runInAction } from 'mobx';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { getNoticeList } from '../api';
import _ from 'lodash';
import globalStore from '@/stores';

class DeskAnnouncementSercice {
  timer = null
  duration = 5000 // 动画时间（包括tansition的过渡时间）

  initData() {
    const tasks = [this.getNoticeListWithoutPicture()];
    tasks.push(this.getNoticeListWithPicture());
    return Promise.all(tasks);
  }

  // 点击公告项
  handleNoticeClick = (id, isRead, title) => {
    reportUserBehaviorCgi({
      data: {
        behavior: '点击概览公告板',
        page1: '概览',
        relation_id: id,
        relation_type: 'notice',
        relation_name: title,
      },
    });
    if (!isRead) {
      noticeService.handleNoticeReaded(id, '概览', title);
    }
  }

  // 获取无图片公告数据 (现在需求改了: 要包括带图+不带图的)
  getNoticeListWithoutPicture = () => {
    return getNoticeList({
      data: { is_home_page: 1 },
    }).then(
      (res) => {
        const newArr = res.code === 0 ? res.data.list || [] : [];
        runInAction(() => {
          noticeStore.deskAnnouncementStore.noticeDataWithoutPicture = newArr;
        });
      },
      (err) => {
        runInAction(() => {
          noticeStore.deskAnnouncementStore.noticeDataWithoutPicture = [];
        });
      },
    );
  }

  // 获取带图片公告数据
  getNoticeListWithPicture = () => {
    return getNoticeList({
      data: { is_home_page: 1, has_home_page_picture: 1 },
    }).then(
      (res) => {
        const newArr = res.code === 0 ? res.data.list || [] : [];
        runInAction(() => {
          noticeStore.deskAnnouncementStore.noticeDataWithPicture = newArr;
        });
      },
      (err) => {
        runInAction(() => {
          noticeStore.deskAnnouncementStore.noticeDataWithPicture = [];
        });
      },
    );
  }

  // 为数据源标记消息已读
  @action
  noticeReadedMark(id) {
    noticeStore.deskAnnouncementStore.noticeData = noticeStore.deskAnnouncementStore.noticeData.map((item) => {
      if (item.id === id) {
        item.is_read = 1;
      }
      return item;
    });
  }

  // 负责按照数组的索引设置order
  // 目前用不到这段代码，暂时保留
  setOrder = (index) => {
    const newIndex = typeof index === 'undefined' ? noticeStore.deskAnnouncementStore.currentPageIndex : index;
    const { slider } = noticeStore.deskAnnouncementStore;
    let { recorder } = noticeStore.deskAnnouncementStore;
    if (!slider) {
      return;
    }
    slider.style.transition = 'unset';
    const items = slider.querySelectorAll('li');

    if (!recorder.length) {
      // 初始化记录数组
      recorder = _.filter(
        _.map(items, (item, i) => item.getAttribute('data-index')),
        (i) => !!i,
      );

      // 把最后一个提到第一个
      if (!recorder.length) {
        recorder.unshift(recorder.pop());
      }
    } else {
      // 将第一个拉到最后一个
      recorder.push(recorder.shift());

      // 将index提到第二个
      recorder.splice(1, 0, recorder.splice(recorder.indexOf(newIndex.toString()), 1)[0]);
    }
    // 按照记录数组设置order
    recorder.forEach((item, i) => {
      const temp = slider.querySelector(`li[data-index='${item}']`);
      temp.style.order = i;
      temp.setAttribute('data-order', i);
    });

    // 调整后瞬间移动至第一个，无感知
    slider.style.transform = 'translate(0)';
    if (recorder.length !== 1) {
      this._setAnimate();
    }
  }

  // 动画处理
  @action
  _setAnimate = () => {
    const { slider } = noticeStore.deskAnnouncementStore;
    if (!slider) {
      return;
    }
    slider.style.transition = 'all .5s ease';
    this.clearTimer();
    this.timer = setTimeout(() => {
      runInAction(() => {
        noticeStore.deskAnnouncementStore.currentPageIndex = noticeStore.deskAnnouncementStore.currentPageIndex + 1 > noticeStore.deskAnnouncementStore.recorder.length - 1 ? 0 : noticeStore.deskAnnouncementStore.currentPageIndex + 1;
      });
    }, this.duration);
    slider.style.transform = 'translate(-100%)';
  }

  @action
  animateHandle = (i) => {
    // 如果是启动动画，则now应该直接+1展示下一个
    this.clearTimer();
    noticeStore.deskAnnouncementStore.currentPageIndex = 1;
  }

  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }
  }
}

export default new DeskAnnouncementSercice();
